document.addEventListener('DOMContentLoaded', function() {
    if (!document.body.classList.contains('page-template-page-klantenservice')) return;
    const searchInput = document.getElementById('faq-search');
    const searchButton = document.getElementById('faq-search-button');
    const searchResultsCount = document.getElementById('search-results-count');

    const faqQuestions = document.querySelectorAll('.row-faq-question');
    const faqBlocks = document.querySelectorAll('.block-faq');

    function searchFAQs() {
        const searchTerm = searchInput.value.toLowerCase().trim();

        if (searchTerm === '') {
            resetSearch();
            return;
        }

        let matchCount = 0;

        faqBlocks.forEach(block => {
            block.style.display = 'none';
        });

        faqQuestions.forEach(question => {
            const questionText = question.querySelector('h5').innerText.toLowerCase();
            const answerText = question.querySelector('.row-faq-answer') ?
                question.querySelector('.row-faq-answer').innerText.toLowerCase() : '';

            const rowFaq = question.closest('.row-faq');
            const parentBlock = question.closest('.block-faq');

            if (questionText.includes(searchTerm) || answerText.includes(searchTerm)) {
                showResult(rowFaq, parentBlock);
                matchCount++;
                return;
            }

            const questionWords = questionText.split(/\s+/);
            const answerWords = answerText.split(/\s+/);
            const allWords = [...questionWords, ...answerWords];

            const validWords = allWords.filter(word => word.length >= 4);

            for (const word of validWords) {
                if (calculateMatchPercentage(word, searchTerm) >= 80) {
                    showResult(rowFaq, parentBlock);
                    matchCount++;
                    return;
                }
            }

            rowFaq.style.display = 'none';
        });

        if (matchCount > 0) {
            searchResultsCount.innerHTML = `${matchCount} ${matchCount === 1 ? 'resultaat' : 'resultaten'} gevonden voor "${searchTerm}"`;
        } else {
            searchResultsCount.innerHTML = `Geen resultaten gevonden voor "${searchTerm}"`;
        }
        searchResultsCount.style.display = 'block';
    }

    function calculateMatchPercentage(word, searchTerm) {
        if (word.length < searchTerm.length * 0.7 || word.length > searchTerm.length * 1.3) {
            return 0;
        }

        if (word.startsWith(searchTerm) || searchTerm.startsWith(word)) {
            const minLength = Math.min(word.length, searchTerm.length);
            const maxLength = Math.max(word.length, searchTerm.length);

            return (minLength / maxLength) * 100;
        }

        let commonChars = 0;
        let searchChars = searchTerm.split('');

        for (const char of word) {
            const index = searchChars.indexOf(char);
            if (index !== -1) {
                commonChars++;
                searchChars.splice(index, 1);
            }
        }

        const maxUniqueChars = Math.max(
            new Set(word).size,
            new Set(searchTerm).size
        );

        return (commonChars / maxUniqueChars) * 100;
    }

    function showResult(rowFaq, parentBlock) {
        rowFaq.style.display = 'block';
        if (parentBlock) {
            parentBlock.style.display = 'block';
        }
    }

    function resetSearch() {
        faqBlocks.forEach(block => {
            block.style.display = 'block';
        });

        document.querySelectorAll('.row-faq').forEach(row => {
            row.style.display = 'block';
        });

        searchResultsCount.style.display = 'none';
        searchResultsCount.innerHTML = '';
    }

    searchButton.addEventListener('click', searchFAQs);
    searchInput.addEventListener('keyup', function(event) {
        if (event.key === 'Enter') {
            searchFAQs();
        } else if (searchInput.value === '') {
            resetSearch();
        }
    });
});
